/**
 * Заголовок главной страницы — единственный источник правды для вкладки и поиска.
 * Должен совпадать с <title> в index.html: index.html отдаётся поисковику и
 * видён до загрузки JS, этот текст подставляется после.
 */
const HOME_TITLE: Record<string, string> = {
  ru: 'Онлайн-чат для сайта, Telegram и соцсетей — ChatX',
  en: 'Live chat for your website, Telegram and social media — ChatX',
}

export function homeTitle(language: string): string {
  return HOME_TITLE[language] ?? HOME_TITLE.ru
}
